export default function ({ store, redirect }) {
    if (store.state?.map?.mapModule?.metaverseId !== 1) {
        return redirect('/dashboard');
    }
}
